import { useState } from 'react';
import { auth as authApi } from '../../utils/api';
import {
  MSG_ISCRIZIONI_CHIUSE, MSG_LISTA_ATTESA_FATTO, MSG_LISTA_ATTESA_PRIVACY,
  datiListaAttesa, emailValida, erroreListaAttesa, urlRichiediDemo,
} from '../../pages/iscrizioniChiuse';

// DBT-228 + CAP-024 (DEC-176) — chi trova le iscrizioni chiuse legge il testo
// deciso da Vale e può lasciare un contatto per la lista d'attesa: email
// obbligatoria, nome e telefono facoltativi. NESSUN campo password.
// «Richiedi una demo» resta visibile. Testo dei pulsanti in var(--ink):
// almeno 5,44:1 sul gradiente (WCAG AA 4,5:1, [[DEC-171]]).
export default function AvvisoIscrizioniChiuse({ provenienza = 'app' }) {
  const [email, setEmail] = useState('');
  const [nome, setNome] = useState('');
  const [telefono, setTelefono] = useState('');
  const [sitoWeb, setSitoWeb] = useState('');  // campo trappola, invisibile alle persone
  const [stato, setStato] = useState('modulo');  // 'modulo' | 'invio' | 'fatto'
  const [errore, setErrore] = useState('');

  const invia = async (e) => {
    e.preventDefault();
    setErrore('');
    if (!emailValida(email)) {
      setErrore('Scrivi un indirizzo email valido.');
      return;
    }
    setStato('invio');
    try {
      await authApi.listaAttesa(datiListaAttesa({ email, nome, telefono, sitoWeb }, provenienza));
      setStato('fatto');
    } catch (err) {
      setErrore(erroreListaAttesa(err));
      setStato('modulo');
    }
  };

  return (
    <div data-testid="iscrizioni-chiuse" style={{ textAlign: 'center' }}>
      <p style={{ fontSize: 13, color: 'var(--ds-text)', lineHeight: 1.6, margin: '0 0 16px' }}>
        {MSG_ISCRIZIONI_CHIUSE}
      </p>

      {stato === 'fatto' ? (
        <p data-testid="lista-attesa-fatto" style={{ fontSize: 13, color: 'var(--ds-text)', lineHeight: 1.6, margin: '0 0 16px', padding: '10px 12px', background: 'var(--chip)', borderRadius: 'var(--radius-base)' }}>
          {MSG_LISTA_ATTESA_FATTO}
        </p>
      ) : (
        <form data-testid="lista-attesa" onSubmit={invia} noValidate style={{ display: 'flex', flexDirection: 'column', gap: 10, textAlign: 'left', marginBottom: 12 }}>
          <div aria-hidden="true" style={{ position: 'absolute', left: -10000, width: 1, height: 1, overflow: 'hidden' }}>
            <label htmlFor="la-sito-web">Sito web</label>
            <input id="la-sito-web" type="text" tabIndex={-1} autoComplete="off" value={sitoWeb} onChange={(e) => setSitoWeb(e.target.value)} />
          </div>
          <div>
            <label htmlFor="la-email" style={labelStyle}>Email</label>
            <input id="la-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@azienda.it" autoComplete="email" maxLength={254} style={inputStyle} />
          </div>
          <div>
            <label htmlFor="la-nome" style={labelStyle}>Nome (facoltativo)</label>
            <input id="la-nome" type="text" value={nome} onChange={(e) => setNome(e.target.value)} autoComplete="name" maxLength={200} style={inputStyle} />
          </div>
          <div>
            <label htmlFor="la-telefono" style={labelStyle}>Telefono (facoltativo)</label>
            <input id="la-telefono" type="tel" value={telefono} onChange={(e) => setTelefono(e.target.value)} autoComplete="tel" maxLength={30} style={inputStyle} />
          </div>
          {errore && <div role="alert" style={erroreStyle}>{errore}</div>}
          <button type="submit" disabled={stato === 'invio'} className="gradient-brand" style={{ ...btnPrimario, opacity: stato === 'invio' ? 0.7 : 1 }}>
            {stato === 'invio' ? 'Invio in corso…' : 'Avvisami quando apre'}
          </button>
          <p style={{ fontSize: 11, color: 'var(--ds-muted)', lineHeight: 1.5, margin: 0 }}>
            {MSG_LISTA_ATTESA_PRIVACY}{' '}
            <a href={`${process.env.REACT_APP_API_URL || ''}/privacy/`} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--brand)', textDecoration: 'none' }}>
              Informativa privacy
            </a>
          </p>
        </form>
      )}

      <a href={urlRichiediDemo()} style={btnSecondario}>
        Richiedi una demo
      </a>
    </div>
  );
}

const labelStyle = { fontSize: 11, fontWeight: 500, color: 'var(--ds-text)', display: 'block', marginBottom: 6 };
const inputStyle = {
  width: '100%', padding: '9px 12px', borderRadius: 'var(--radius-base)', border: '1px solid var(--ds-border)',
  background: 'var(--chip)', fontSize: 12, color: 'var(--ds-text)', boxSizing: 'border-box', minHeight: 44,
};
const btnPrimario = {
  width: '100%', minHeight: 44, padding: '11px 0', borderRadius: 'var(--radius-base)', border: 'none',
  cursor: 'pointer', fontSize: 13, fontWeight: 500, color: 'var(--ink)', boxShadow: '0 2px 10px rgba(35,38,47,0.06)',
};
const btnSecondario = {
  display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', minHeight: 44, boxSizing: 'border-box',
  borderRadius: 'var(--radius-base)', border: '1px solid var(--ds-border)', background: 'transparent',
  fontSize: 13, fontWeight: 500, color: 'var(--ink)', textDecoration: 'none',
};
const erroreStyle = {
  fontSize: 11, color: 'var(--ds-danger)', background: 'color-mix(in srgb, var(--ds-danger) 8%, transparent)',
  borderRadius: 'var(--radius-base)', padding: '8px 12px',
};
